import { ActionHandler, ActionHandlerParams } from "..";
import { saveAnswers } from "./saveAnswers";
import { trackLead } from "src/utils/services/ConversionTracker";
import { trackGotEmail } from "src/utils/api/tracker";
import saveToBraze from "src/utils/brazeUploader";
import { requiresDoubleOptInForEmail } from "src/utils/userSegment/features";
import { getAndMaybeSavePendingDoubleOptInStatus } from "src/utils/gdpr";

type Params = {
  lead?: string;

  dateKey?: string;
  extraProps?: JsonObject;
};

export const onCompleteMainSurvey: ActionHandler = async (
  actionParams: {
    params: Params;
  } & ActionHandlerParams
): Promise<void> => {
  const surveyAnswers = await saveAnswers(actionParams);

  if (surveyAnswers.gdprConsent && requiresDoubleOptInForEmail()) {
    await getAndMaybeSavePendingDoubleOptInStatus();
  }

  // Send the user chosen first name to Braze as well for some extra DRIP customization
  const { firstName } = surveyAnswers;
  if (firstName) {
    await saveToBraze({ user: { firstName } });
  }

  const email = surveyAnswers.email || "";
  trackLead(email);
  if (email) {
    trackGotEmail(email);
  }
};
